exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".eye-open-1{\n    fill:var(--gray);\n}\n\n.eye-open-2{\n    fill:var(--dark);\n}\n", ""]);
